import { LoyaltyType } from '../customer.types';

export class CustomerLoyalty {
	id: string;
	customerId: number;
	type: LoyaltyType;
	points: number;
}
